import { CommandVersion } from "./command-library.types";
import { storeEvent } from "./data-collection";
export function recordEvent(ipmId, command, name) {
    void storeEvent(ipmId || "no ipm value", command, CommandVersion[command], name);
}
export function recordGenericEvent(name) {
    void storeEvent("__no_ipm__", "__no_command__", 0, name);
}
